<div class="MainBg">
  <div class="MainInnerFormWithoutFlex" style="background-color: transparent">
    <!-- comprehensive summary starts -->
    <div *ngIf="IsMobile" class="CurrentHoldings GridGapTop">
      <div class="Summary">
        <div class="Grid1 mb-3">
          <div class="text-left">
            <label>Current Value</label>
            <div class="Number">₹{{SummaryReportTotal[0].CostCurrentValue}}</div>
          </div>
          <div class="text-right">
            <label>Investment</label>
            <div class="Number">₹{{SummaryReportTotal[0].totalAmt}}</div>
          </div>
        </div>
        <div class="Grid2">
          <div class="text-left">
            <label>Total G/L(₹)</label>
            <div class="Number" [ngClass]="SummaryReportTotal[0].TotalGainLoss > 0 ? 'PositiveValue':'NagativeValue'">{{SummaryReportTotal[0].TotalGainLoss}}%</div>
          </div>
          <div class="text-right">
            <label>XIRR</label>
            <div class="Number" [ngClass]="SummaryReportTotal[0].TotalXIRR > 0 ? 'PositiveValue':'NagativeValue' ">{{SummaryReportTotal[0].TotalXIRR}}%</div>
          </div>
        </div>
      </div>
      <div class="TopMost BoxShadow">
        <!-- <div class="SectionTopHeading mb-0 Bottompadding_Mob">
                    <span><img *ngIf="!IsMobile" src="../../assets/images/Head_CurrentHolding.svg" class="svg"
                            width="25px" />Comprehensive Summary </span>

                </div> -->
        <div id="CurrentHoldings" class="tab-content TabContentData tab-content_Mob pt-0">
          <div *ngIf="IsMobile" class="tab-pane fade active show">
            <div class="ReportCard" *ngFor="let c of ReportData; let i = index">
              <div class="Report-1 pb-3">
                <div class="d-flex align-items-end">
                  <span class="Name mr-2"> {{ c.SchemeName }}</span>
                </div>
                <!-- <div class="Summary-1">
                <div>
                  Abs. Rtn. :
                  {{ CHAssetWise.AbsReturn | number : "1.2-2" }}%
                </div>
                  <img src="../../assets/images/IIFL_New_Icons/circle.svg" class="Circle" alt="">
                <div>
                  Alloc. :
                  {{ CHAssetWise.Allocation.toLocaleString("en-IN", { minimumFractionDigits: 2,
                      maximumFractionDigits: 2 })
                  }}%
                </div>
              </div> -->
              </div>
              <div class="ReportDetails ForComprehensive">
                <div>
                  <div class="GridTitle">Investment</div>
                  <div>
                    ₹
                    {{
                    c.InvestmentAmount.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                    })
                    }}
                  </div>
                </div>
                <div>
                  <div class="GridTitle">Cur.val.</div>
                  <div>
                    ₹
                    {{
                    c.Currentvalue.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                    })
                    }}
                  </div>
                </div>
                <div class="text-center">
                  <div class="GridTitle ">Latest NAV</div>
                  <div>
                    {{
                    c.NAV.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                    })
                    }}%
                  </div>
                </div>
                <div class="text-right">
                  <div class="GridTitle">Bal. Units</div>
                  <div>
                    {{
                    c.Unit.toLocaleString("en-IN", {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                    })
                    }}%
                  </div>
                </div>
                <!-- <div>
               
                <div class="GridTitle">Pur.val.</div>
                <div
                 
                >
                  ₹
                  {{
                    c.CostCurrentValue.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}
                </div>
              </div>
              <div>
                <div class="GridTitle">Redemption</div>
                <div>
                  ₹
                  {{
                    c.Redemption.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}
                </div>
              </div>
              <div>
                <div class="GridTitle">Div Reinvest</div>
                <div>
                  ₹
                  {{
                    c.DividendReinvest.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}
                </div>
              </div>
              <div>
                <div class="GridTitle">Div Paid</div>
                <div>
                  {{
                    c.DividentPayout.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}%
                </div>
              </div>
              <div>
                <div class="GridTitle">Purchased</div>
                <div>
                 
                  {{ c.UnitsPurchased }}%
                </div>
              </div>
              <div class="">
                <div class="GridTitle ">Reinvested</div>
                <div>
                  {{
                    c.UnisReinvested.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}%
                </div>
              </div>
              <div class="text-center">
                <div class="GridTitle ">Sold</div>
                <div>
                  {{
                    c.UnitsSold.toLocaleString("en-IN", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })
                  }}%
                </div>
              </div> -->


                <!-- <div class="text-right">
                <div class="GridTitle ">Cur. Date</div>
                <div>
                
                  {{ c.NAVDate  }}
                </div>
              </div>
              <div>
                <div class="GridTitle">Average Price</div>
                <div>
                  
                  {{ c.PurWtAvg }}
                </div>
              </div>
              <div class="text-center">
                <div class="GridTitle ">Realised</div>
                <div>
                 
                  {{ c.GainLossRealised }}
                </div>
              </div>
            
            <div class="text-right">
              <div class="GridTitle ">Unrealised</div>
              <div>
               
                {{ c.GainLoss }}
              </div>
            </div>
            <div>
              <div class="GridTitle">Total</div>
              <div>
               
                {{ c.GainLoss }}
              </div>
            </div>
            <div class="text-center">
              <div class="GridTitle ">Absolute(%)</div>
              <div>
               
                {{ c.Absreturn }}%
              </div>
            </div>
            <div class="text-right">
              <div class="GridTitle ">XIRR (%)</div>
              <div>
               
                {{ c.XIRR }}%
              </div>
            </div>
            <div>
              <div class="GridTitle">% of Portfolio</div>
              <div>
               
                {{ c.PercOfPortfolio }}
              </div>
            </div> -->
              </div>
              <!-- CS Button  -->
              <div class="FlexRow_Mob">
                <div>
                  <button class=" ComprehensiveSummaryBtn_Mob ColorGrey_Mob">Details</button>
                </div>
                <div>
                  <button routerLink="/transaction-new-latest/lumpsum" routerLinkActive="active"
                    class="ComprehensiveSummaryBtn_Mob ColorGreenLight_Mob sm">Buy</button>
                </div>
                <div>
                  <button routerLink="/transaction-new-latest/sip" routerLinkActive="active"
                    class="ComprehensiveSummaryBtn_Mob ColorGreenDark_Mob sm">SIP</button>
                </div>
                <div>
                  <button routerLink="/reports-new/portfolio-report-deatiled" routerLinkActive="active"
                    class="ComprehensiveSummaryBtn_Mob ColorGrey_Mob ">More</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- comprehensive summary ends-->
  </div>
</div>